const shouldMock = process.env.VUE_APP_MOCK_API === 'true' && process.env.NODE_ENV !== 'production'

export default {
    shouldMock,
    handleMock: (cb = () => ({})) => {
        const response = cb()
        return new Promise(resolve => {
            setTimeout(() => resolve(response), 500)
        })
    }
}
